<template>
  <div>
    <b-row class="mb-1">
      <b-col v-if="!noOpen" class="col-auto">
        <h4 class="mb-0">
          <i class="fa fa-fw fa-film mt-1"></i>
        </h4>
      </b-col>
      <b-col>
        <b-form-input
          v-model="query"
          :placeholder="trans('search')"
          type="search"
          size="sm"
          class="mb-1"
          @search="onSearch"
          @keydown.enter="onSearch"
        />
        <tags-filter
          :organization="organization"
          multiple
          v-model="tags"
          type="video"
          @input="onSearch"
          allow-none
          :is-none="tag_is_none"
          @is-none="tag_is_none = $event"
          :all-tags="all_tags"
          @all-tags="all_tags = $event"
        ></tags-filter>
        <small class="text-muted">
          {{ totalRows }}
        </small>
      </b-col>
      <b-col class="col-auto">
        <b-button size="sm" variant="link" class="pb-0" :title="trans('upload')" :disabled="busy" v-if="!hideUpload" v-b-modal.upload-video-modal>
          <i class="fa fa-fw fa-cloud-upload-alt"></i>
        </b-button>
        <b-button size="sm" variant="link" class="pb-0" @click="onRefresh" :title="trans('refresh')" :disabled="busy">
          <i class="fa fa-fw fa-redo" v-if="!busy"></i>
          <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table
          id="your-videos"
          ref="table"
          class="bg-white table-row-click"
          bordered
          small
          responsive
          show-empty
          :fields="fields"
          :items="provider"
          :per-page="perPage"
          :current-page="currentPage"
          @row-clicked="onRowClick"
        >
          <template v-slot:empty>
            <p align="center">{{ trans('no_video_found') }}</p>
          </template>
          <template v-slot:cell(thumb_url)="data">
            <div class="img-wrapper text-center">
              <img :src="data.value" alt="data.item.name" />
            </div>
          </template>
          <template v-slot:cell(name)="data">
            {{ data.value }}
            <sup v-if="data.item.publish_to_partner">
              <b-badge variant="primary">
                {{ organization.can_publish && organization.partner == data.item.publish_to_partner ? trans('published') : data.item.publish_to_partner }}
              </b-badge>
            </sup>
            <small class="d-block mt-2 text-muted">
              {{ data.item.short_url }}
            </small>
            <tags
              v-if="data.item.organization_id == organization.id"
              :organization="organization"
              :model="data.item"
              :hide-edit="videoNameOnly"
              type="video"
              :all-tags="all_tags"
              @all-tags="all_tags = $event"
              :disabled="busy"
            ></tags>
          </template>
          <template v-slot:cell(action)="data">
            <a :href="data.item.short_url" target="_blank">
              <i class="fa fa-fw fa-external-link-alt text-muted"></i>
            </a>
            <b-link :href="`/organization/${organization.id}/media/qr_code/${data.item.id}`" target="_blank">
              <i class="fa fa-fw fa-qrcode text-muted"></i>
            </b-link>
          </template>
        </b-table>
        <b-pagination
          :per-page="perPage"
          :current-page="currentPage"
          :total-rows="totalRows"
          v-model="currentPage"
          aria-controls="your-videos"
          align="center"
        />
      </b-col>
    </b-row>

    <video-modal
      v-if="!noOpen"
      :organization="organization"
      :video="item"
      @saved="onRefresh"
      @deleted="onRefresh"
    ></video-modal>

    <upload-video-modal
      :organization="organization"
      @uploaded="onUploaded"
    ></upload-video-modal>

  </div>
</template>

<style>
  table#your-videos td>.img-wrapper>img {
    height: 90px;
  }
</style>

<script>
  import UploadVideoModal from './UploadVideoModal'
  import VideoModal from './VideoModal'
  import Tags from './../tag/Tags'
  import TagsFilter from './../tag/TagsFilter'

  export default {
    props: {
      organization: Object,
      zoom: Object,
      hideUpload: Boolean, // hide-upload
      videoNameOnly: Boolean, // video-name-only
      noOpen: Boolean, // no-open
      search: String,
      perPage: {
        type: Number,
        default: 5
      },
    },
    components: {
      UploadVideoModal,
      VideoModal,
      Tags,
      TagsFilter,
    },
    data() {
      let fields = [
        {key: 'thumb_url', label: trans('video')},
        {key: 'name', label: trans('name'), class: 'table-row-width-200'},
      ]
      if (!this.videoNameOnly) {
        fields.push({
          key: 'description',
          label: trans('description'),
          class: 'table-row-width-200',
        })
        fields.push({
          key: 'duration',
          label: trans('duration'),
          formatter(value) {
            return value ? moment().startOf('day').seconds(value).format('H:mm:ss') : null
          },
        })
        fields.push({key: 'human_readable_size', label: trans('size')})
        fields.push({
          key: 'recorded_at',
          label: trans('recorded'),
          formatter(value) {
            return value ? moment(value).format('LLL') : null
          },
        })
        fields.push({
          key: 'created_at',
          label: trans('uploaded'),
          formatter(value) {
            return moment(value).format('LLL')
          },
        })
        fields.push({key: 'action', label: ''})
      }

      return {
        trans: trans,
        moment: moment,
        error: null,
        busy: false,
        fields: fields,
        items: [],
        currentPage: 1,
        totalRows: 0,
        item: null,
        showFirstVideo: false,
        query: this.search || null,
        tags: null,
        all_tags: null,
        tag_is_none: false,
      }
    },
    methods: {
      onSearch() {
        this.currentPage = 1
        this.$refs.table.refresh()
        this.$emit('search', this.query)
      },
      onUploaded(media) {
        if (media.id) {
          // The video is ready - refresh to show it
          this.currentPage = 1
          this.onRefresh()
        }
        else if (media.message) {
          // Background processing
          _.toastSuccess(this, media.message)
          //this.showFirstVideo = true
          setTimeout(() => {
            this.onRefresh()
          }, 5000)
        }
      },
      onRefresh() {
        this.$refs.table.refresh()
      },
      onRowClick(item) {
        this.$emit('choose', item)
        if (this.noOpen) return
        this.item = item
        setTimeout(() => {
          this.$bvModal.show('show-video-modal')
        }, 1)
      },
      provider() {
        this.error = null
        this.busy = true
        let url = `/organization/${this.organization.id}/media/video?page=${this.currentPage}&per_page=${this.perPage}`
        if (this.query) url += '&name=' + encodeURIComponent(this.query)
        if (this.tag_is_none) url += `&tag=__none__`
        else if (this.tags && this.tags.length > 0) {
          this.tags.forEach(tag => {
            url += `&tags[]=${encodeURIComponent(tag)}`
          })
        }
        return axios.get(url)
        .then(response => {
          this.busy = false
          this.currentPage = response.data.current_page
          this.totalRows = response.data.total
          this.items = response.data.data
          if (this.showFirstVideo) {
            this.showFirstVideo = false
            if (this.items.length > 0) {
              this.$nextTick(() => {
                this.onRowClick(this.items[0])
              })
            }
          }
          return this.items
        })
        .catch(error => {
          this.busy = false
          this.handleError(error)
          this.items = []
          return this.items
        })
      },
      handleError(error) {
        this.busy = false
        this.error = _.errorFromAjax(error)
        this.$bvToast.toast(this.error, {
          title: trans('error'),
          variant: 'danger',
          solid: true,
        })
      }
    },
    mounted() {
      window.videosTableComponent = this
    },
  }
</script>